<div class="autocomplete-container">
  
  <c-input
    [type]="'text'"
    [label]="label"
    [formControl]="control"
    [clearInput]="true"
    [iconStart]="iconStart"
    [icon]="icon"
    [required]="required"
    [clearInput]="clearInput"
  />

  @if (list?.length > 0 && !(list?.length === 1 && list[0].label === control.value) && !control.disabled) {
  <ion-list #listRef class="autocomplete-list">
    @for (item of list; track item.id) {
    <ion-item class="item" button (click)="select(item)" detail="false">
      {{ item.label }}
    </ion-item>
    }
  </ion-list>
  }
</div>
